import { render, staticRenderFns } from "./inviteCode.vue?vue&type=template&id=dc06a654&scoped=true&"
import script from "./inviteCode.vue?vue&type=script&lang=js&"
export * from "./inviteCode.vue?vue&type=script&lang=js&"
import style0 from "./inviteCode.vue?vue&type=style&index=0&id=dc06a654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc06a654",
  null
  
)

export default component.exports